var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMediaConsumption(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1081",
    "data-name": "Rectangle 1081",
    width: 35.72,
    height: 25.999,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_media_consumption",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(335.973 227.421)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1077",
    "data-name": "Rectangle 1077",
    width: 34.255,
    height: 22.591,
    transform: "translate(0.731 0.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21818",
    "data-name": "Path 21818",
    d: "M1.462,1.462h32.8V22.591H1.462ZM0,24.056H35.72V0H0Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206-2",
    "data-name": "Group 206",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21819",
    "data-name": "Path 21819",
    d: "M9.617,2.565a1.25,1.25,0,1,1,1.248,1.248A1.25,1.25,0,0,1,9.617,2.565",
    transform: "translate(19.308 2.637)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21820",
    "data-name": "Path 21820",
    d: "M9.617,3.853A1.25,1.25,0,1,1,10.865,5.1,1.25,1.25,0,0,1,9.617,3.853",
    transform: "translate(19.308 5.223)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1078",
    "data-name": "Rectangle 1078",
    width: 5.002,
    height: 1.462,
    transform: "translate(2.117 24.537)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1079",
    "data-name": "Rectangle 1079",
    width: 5.002,
    height: 1.462,
    transform: "translate(28.598 24.537)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1080",
    "data-name": "Rectangle 1080",
    width: 1.475,
    height: 2.219,
    transform: "translate(28.084 17.728) rotate(-45)",
    fill: "#d84f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21821",
    "data-name": "Path 21821",
    d: "M22.907,17.463H1.221L22.907,1.314Z",
    transform: "translate(2.452 2.638)",
    fill: "#4b89c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21822",
    "data-name": "Path 21822",
    d: "M1.763,1.315,1.221,17.463,22.907,1.315Z",
    transform: "translate(2.452 2.638)",
    fill: "#5ebae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21823",
    "data-name": "Path 21823",
    d: "M24.126,18.681H.978V1.071H24.126ZM2.44,17.22H22.664V2.536H2.44Z",
    transform: "translate(1.964 2.149)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21824",
    "data-name": "Path 21824",
    d: "M12.138,11.506A3.157,3.157,0,1,1,15.3,8.351a3.16,3.16,0,0,1-3.161,3.155m0-4.839a1.683,1.683,0,1,0,1.687,1.684,1.685,1.685,0,0,0-1.687-1.684",
    transform: "translate(18.036 10.425)",
    fill: "#404040"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMediaConsumption);
export default __webpack_public_path__ + "static/media/ic_media_consumption.306ee62d947047e4ccc0640be2c37e57.svg";
export { ForwardRef as ReactComponent };